import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, Clock } from "lucide-react";
import { IMAGES } from "../lib/data";
import { BLOG_POSTS as POSTS } from "../lib/blog";
import { PageHero, CTABand } from "../components/site/Bits";
import { Reveal } from "../components/site/Reveal";
import { Seo } from "../components/site/Seo";

function formatDate(iso) {
  return new Date(iso + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <Seo
        title="Blog"
        description="Field-tested insights on spill response, water treatment, ground protection, and jobsite environmental compliance from the OneHarvest team."
      />
      <PageHero
        kicker="Insights & Field Notes"
        title="Practical guidance for the field."
        subtitle="Straight-talk articles on spill response, water treatment, ground protection, and staying compliant — written for the crews who do the work."
        image={IMAGES.pipeline}
      />

      <section className="bg-background">
        <div className="container-x py-24">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {POSTS.map((post, i) => (
              <Reveal key={post.slug} delay={(i % 3) * 0.06}>
                <Link
                  to={`/blog/${post.slug}`}
                  data-testid={`blog-card-${post.slug}`}
                  className="group flex h-full flex-col overflow-hidden border border-border bg-card hover:border-flame/60 hover:-translate-y-1.5 hover:shadow-2xl transition-[transform,box-shadow,border-color] duration-300 ease-[cubic-bezier(0.25,1,0.5,1)]"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img src={post.heroImage} alt={post.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <span className="absolute top-4 left-4 bg-flame text-white text-xs font-semibold uppercase tracking-wider px-3 py-1">{post.category}</span>
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      <span className="inline-flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" />{formatDate(post.date)}</span>
                      <span className="inline-flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" />{post.readTime}</span>
                    </div>
                    <h2 className="mt-3 font-display font-bold text-xl text-ink leading-snug group-hover:text-flame transition-colors">{post.title}</h2>
                    <p className="mt-2 flex-1 text-sm text-muted-foreground leading-relaxed">{post.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-ink font-semibold text-sm group-hover:text-flame transition-colors">
                      Read article <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
